import type {
  DecoratedDesignResponse,
  Product,
  ProjectItem,
} from '@customink/project-service-react-components';

import { biggestColorCount } from '@/utils/design';

export enum GroupValidationResult {
  ENTER_QUANTITIES = 'enter_quantities',
  PROJECT_ITEM_MISSING_QUANTITIES = 'project_item_missing_quantities',
  TOO_MANY_COLORS = 'too_many_colors',
}

export function hasNoQuantities(items: ProjectItem[]): boolean {
  return items.every((item) => item.totalQuantity === 0);
}

export function hasMissingQuantities(items: ProjectItem[]): boolean {
  return items.some((item) => item.totalQuantity === 0);
}

export function hasExceededColorLimit(
  design: DecoratedDesignResponse,
  product?: Product,
): boolean {
  const totalColors = biggestColorCount(design);
  return !!product?.color_limit && totalColors > product.color_limit;
}

export function validateProjectItemGroup({
  projectItems,
  design,
  product,
}: {
  projectItems: ProjectItem[];
  design: DecoratedDesignResponse;
  product?: Product;
}): GroupValidationResult | null {
  if (hasNoQuantities(projectItems)) {
    return GroupValidationResult.ENTER_QUANTITIES;
  }

  if (hasExceededColorLimit(design, product)) {
    return GroupValidationResult.TOO_MANY_COLORS;
  }

  if (hasMissingQuantities(projectItems)) {
    return GroupValidationResult.PROJECT_ITEM_MISSING_QUANTITIES;
  }

  return null;
}

export function validateEditGroupSizes({
  projectItems,
}: {
  projectItems: ProjectItem[];
}) {
  if (hasNoQuantities(projectItems)) {
    return GroupValidationResult.ENTER_QUANTITIES;
  }

  if (hasMissingQuantities(projectItems)) {
    return GroupValidationResult.PROJECT_ITEM_MISSING_QUANTITIES;
  }

  return null;
}
